import {
  INIT_EXCHANGE_API,
  ACCEPT_EXCHANGE_API,
  KYC_URL_API,
  KYB_URL_API,
  CURRENCY_ASSET,
  CONVERT_CURRENCY,
  KYC_KUB_STATUS,
  PROOF_OF_FUNDS,
  PASSWORD_STATUS,
  KYC_URL_ADDRESS,
} from "config/api";
import { BaseService } from "./BaseService";
import {
  IOTCInitRequest,
  IOTCAcceptRequest,
  IOTCConvertRequest,
} from "models/otc";

class OTCService extends BaseService {
  public async initExchange(data: IOTCInitRequest): Promise<any> {
    return this.post(INIT_EXCHANGE_API, data);
  }
  public async acceptExchange(
    data: IOTCAcceptRequest,
    id: number
  ): Promise<any> {
    return this.post(ACCEPT_EXCHANGE_API(id), data);
  }
  public async getKYCUrl(clientId: string, id: number): Promise<any> {
    return this.post(KYC_URL_API, {
      clientId,
      requestId: `${id}`,
    });
  }
  public async getKYBUrl(clientId: string, id: number): Promise<any> {
    return this.post(KYB_URL_API, {
      clientId,
      requestId: `${id}`,
    });
  }
  public async getCurrencyAsset(): Promise<any> {
    return this.get(CURRENCY_ASSET);
  }
  public async convertCurrency(data: IOTCConvertRequest): Promise<any> {
    return this.post(CONVERT_CURRENCY, data);
  }
  public async getKYCKYBStatus(id: number): Promise<any> {
    return this.post(KYC_KUB_STATUS(id));
  }
  public async getProofOfFunds(clientId: string, id: number): Promise<any> {
    return this.post(PROOF_OF_FUNDS, {
      clientId,
      requestId: `${id}`,
    });
  }
  public async getPasswordStatus(clientId: string): Promise<any> {
    return this.get(`${PASSWORD_STATUS}?clientId=${clientId}`);
  }
  public async getKYCURLAddress(data: {
    clientId: string;
    requestId: string;
  }): Promise<any> {
    return this.post(KYC_URL_ADDRESS, data);
  }
}

export const otcService = new OTCService();
